import { SelectOptions } from "core/models/Settings";

// Shared platform options for both the product form (AddStoreForm) and the
// brand form (AddBrandForm) so the two stay in sync.
export const PLATFORM_OPTIONS: SelectOptions[] = [
  { label: "Mobile", value: "Mobile" },
  { label: "PC", value: "PC" },
  { label: "Console", value: "Console" },
  { label: "Webgame", value: "Webgame" },
  { label: "PlayStation", value: "PlayStation" },
  { label: "Xbox", value: "Xbox" },
  { label: "Nintendo Switch", value: "Nintendo Switch" },
];
